import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leads/TotalStatisticsHeader'
import LeadssTable from '../components/leads/TotalStatisticsTable'
import Footer from '../components/shared/Footer'

const LeadsList = () => {
    return (
        <>
            <PageHeader>
            
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LeadssTable />
                </div>
            </div>
            
        </>
    )
}

export default LeadsList